import { Link } from "react-router-dom";
import { ArrowRight, Calendar, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface CTASectionProps {
  title?: string;
  subtitle?: string;
  primaryCTA?: string;
  secondaryCTA?: string;
  variant?: "default" | "dark" | "gradient";
}

export function CTASection({
  title = "Pronto para automatizar sua gestão de créditos?",
  subtitle = "Agende uma demonstração e veja como a Cogni pode eliminar o trabalho manual do seu time.",
  primaryCTA = "Agendar demo",
  secondaryCTA = "Falar com especialista",
  variant = "gradient",
}: CTASectionProps) {
  const bgClasses = {
    default: "section-warm",
    dark: "section-dark",
    gradient: "section-gradient-purple relative overflow-hidden",
  };

  const subtitleClasses = {
    default: "text-muted-foreground",
    dark: "text-primary-foreground/80",
    gradient: "text-muted-foreground",
  };

  const primaryButtonClasses = {
    default: "gradient-primary text-primary-foreground",
    dark: "bg-background text-foreground hover:bg-background/90",
    gradient: "gradient-primary text-primary-foreground glow-primary",
  };

  const secondaryButtonVariant = variant === "dark" ? "ghost" : "outline";

  return (
    <section className={`section-padding ${bgClasses[variant]}`}>
      {/* Decorative elements */}
      {variant === "gradient" && (
        <>
          <div className="absolute top-0 left-1/4 w-48 sm:w-64 h-48 sm:h-64 bg-primary/10 rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-1/4 w-36 sm:w-48 h-36 sm:h-48 bg-accent/10 rounded-full blur-3xl" />
        </>
      )}
      <div className="container-narrow text-center relative z-10">
        <h2 className="text-headline font-bold mb-4">{title}</h2>
        <p className={`text-body-lg mb-6 sm:mb-8 max-w-2xl mx-auto ${subtitleClasses[variant]}`}>
          {subtitle}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <Link to="/contato" className="w-full sm:w-auto">
            <Button size="lg" className={`w-full sm:w-auto touch-target ${primaryButtonClasses[variant]}`}>
              <Calendar className="mr-2 h-5 w-5" />
              {primaryCTA}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
          <Link to="/contato" className="w-full sm:w-auto">
            <Button
              size="lg"
              variant={secondaryButtonVariant}
              className={`w-full sm:w-auto touch-target ${variant === "dark" ? "border-current hover:bg-white/10" : ""}`}
            >
              <MessageCircle className="mr-2 h-5 w-5" />
              {secondaryCTA}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
